import USGSMap from 'features/Integrations/features/ConnectedDevices/features/USGSMap/index.web';

const USGSFullScreen = () => <USGSMap />;

export default USGSFullScreen;
